/**
 * ks-buy-button.js
 * Inserts a live "· total kr" label into the add-to-cart button.
 * Reacts to the Horizon theme's variant:update and quantity-selector:update events.
 */
(function () {
  'use strict';

  var VARIANT_UPDATE = 'variant:update';
  var QTY_UPDATE = 'quantity-selector:update';

  function formatTotal(unitCents, qty) {
    var total = (unitCents * qty) / 100;
    return (
      '· ' +
      new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(total) +
      ' kr'
    );
  }

  function getInitialPriceCents(section) {
    // Preferred: read from the variant JSON blob that the Horizon pickers embed
    var scripts = section.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data && typeof data.price === 'number') return data.price;
      } catch (_) {}
    }
    // Fallback: parse the displayed price text (e.g. "149,00 kr" or "149 kr")
    var priceEl = section.querySelector('.price-item--regular, .price-item');
    if (priceEl) {
      var raw = priceEl.textContent.replace(/[^\d,]/g, '').replace(',', '.');
      var parsed = parseFloat(raw);
      if (!isNaN(parsed)) return Math.round(parsed * 100);
    }
    return 0;
  }

  function watchSection(section) {
    var currentPriceCents = 0;
    var currentQty = 1;

    function insertTotalSpan() {
      var btn = section.querySelector('.add-to-cart-button');
      if (!btn || btn.querySelector('.ks-btn-total')) return;
      var span = document.createElement('span');
      span.className = 'ks-btn-total';
      span.setAttribute('aria-hidden', 'true');
      var anchor = btn.querySelector('.add-to-cart-text__content');
      if (anchor) {
        anchor.insertAdjacentElement('afterend', span);
      } else {
        var textWrap = btn.querySelector('.add-to-cart-text');
        if (textWrap) textWrap.appendChild(span);
      }
    }

    function updateTotal() {
      var span = section.querySelector('.ks-btn-total');
      if (!span) return;
      if (currentPriceCents > 0 && currentQty > 0) {
        span.textContent = ' ' + formatTotal(currentPriceCents, currentQty);
      } else {
        span.textContent = '';
      }
    }

    // Initial setup
    currentPriceCents = getInitialPriceCents(section);
    var qtyInput = section.querySelector('.quantity-selector input[type="number"]');
    if (qtyInput) currentQty = parseInt(qtyInput.value, 10) || 1;
    insertTotalSpan();
    updateTotal();

    // Re-insert after any DOM update that wipes the button (variant section re-render)
    var observer = new MutationObserver(function () {
      if (!section.querySelector('.ks-btn-total')) {
        insertTotalSpan();
        updateTotal();
      }
    });
    observer.observe(section, { childList: true, subtree: true });

    // Variant change — price comes from the event's resource object
    section.addEventListener(VARIANT_UPDATE, function (e) {
      var price = e.detail && e.detail.resource && e.detail.resource.price;
      if (typeof price === 'number') {
        currentPriceCents = price;
        // DOM will update; MutationObserver handles re-rendering the span.
        // Also update immediately in case the span survived the re-render.
        updateTotal();
      }
    });

    // Quantity change via the stepper component
    section.addEventListener(QTY_UPDATE, function (e) {
      if (e.detail && typeof e.detail.quantity === 'number') {
        currentQty = e.detail.quantity;
        updateTotal();
      }
    });

    // Also catch manual typing in the quantity input
    section.addEventListener('input', function (e) {
      if (e.target && e.target.matches('.quantity-selector input[type="number"]')) {
        currentQty = parseInt(e.target.value, 10) || 1;
        updateTotal();
      }
    });
  }

  function init() {
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (section.querySelector('.add-to-cart-button')) {
        watchSection(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
